export default "__VITE_ASSET__Bu4yk$wA__"